var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticStyle: { "margin-bottom": "0.24rem" } },
        [
          _c(
            "el-checkbox-group",
            {
              staticStyle: { "margin-bottom": "0.24rem" },
              on: {
                change: function ($event) {
                  ;(_vm.init.page = 1), _vm.getQueryInvoiceList()
                },
              },
              model: {
                value: _vm.init.q.invoicingKinds,
                callback: function ($$v) {
                  _vm.$set(_vm.init.q, "invoicingKinds", $$v)
                },
                expression: "init.q.invoicingKinds",
              },
            },
            _vm._l(_vm.checkData, function (item) {
              return _c(
                "el-checkbox",
                { key: item.label, attrs: { label: item.label } },
                [_vm._v(_vm._s(item.value))]
              )
            }),
            1
          ),
          _c("div", { staticClass: "center" }, [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  "margin-bottom": "0.12rem",
                },
              },
              [
                _c("p", { staticClass: "p1" }, [_vm._v("订单编号:")]),
                _c("el-input", {
                  staticStyle: { width: "1.6rem", "margin-right": "0.1rem" },
                  attrs: { size: "small", placeholder: "订单编号" },
                  model: {
                    value: _vm.init.q.orderNumber,
                    callback: function ($$v) {
                      _vm.$set(_vm.init.q, "orderNumber", $$v)
                    },
                    expression: "init.q.orderNumber",
                  },
                }),
                _c("p", { staticClass: "p1" }, [_vm._v("团号:")]),
                _c("el-input", {
                  staticStyle: { width: "0.6rem", "margin-right": "0.1rem" },
                  attrs: { size: "small", placeholder: "团号" },
                  model: {
                    value: _vm.init.q.planId,
                    callback: function ($$v) {
                      _vm.$set(_vm.init.q, "planId", $$v)
                    },
                    expression: "init.q.planId",
                  },
                }),
                _c("p", { staticClass: "p1" }, [_vm._v("申请日期:")]),
                _c("el-date-picker", {
                  staticStyle: { "margin-right": "0.05rem", width: "1.5rem" },
                  attrs: {
                    size: "small",
                    "value-format": "yyyy-MM-dd",
                    type: "date",
                    placeholder: "申请日期",
                  },
                  on: {
                    change: function ($event) {
                      ;(_vm.init.page = 1), _vm.getQueryInvoiceList()
                    },
                  },
                  model: {
                    value: _vm.init.q.createTimeStr,
                    callback: function ($$v) {
                      _vm.$set(_vm.init.q, "createTimeStr", $$v)
                    },
                    expression: "init.q.createTimeStr",
                  },
                }),
                _c("p", { staticClass: "p1" }, [_vm._v("发票金额:")]),
                _c("el-input", {
                  staticStyle: { width: "1.1rem", "margin-right": "0.1rem" },
                  attrs: {
                    size: "small",
                    type: "number",
                    placeholder: "发票金额",
                  },
                  model: {
                    value: _vm.init.q.fapPrice,
                    callback: function ($$v) {
                      _vm.$set(_vm.init.q, "fapPrice", $$v)
                    },
                    expression: "init.q.fapPrice",
                  },
                }),
                _c("p", { staticClass: "p1" }, [_vm._v("抬头类型:")]),
                _c("el-input", {
                  staticStyle: { width: "1.6rem", "margin-right": "0.1rem" },
                  attrs: { size: "small", placeholder: "抬头类型" },
                  model: {
                    value: _vm.init.q.lookUp,
                    callback: function ($$v) {
                      _vm.$set(_vm.init.q, "lookUp", $$v)
                    },
                    expression: "init.q.lookUp",
                  },
                }),
                _c("p", { staticClass: "p1" }, [_vm._v("稅号:")]),
                _c("el-input", {
                  staticStyle: { width: "1.6rem", "margin-right": "0.1rem" },
                  attrs: { size: "small", placeholder: "稅号" },
                  model: {
                    value: _vm.init.q.duty,
                    callback: function ($$v) {
                      _vm.$set(_vm.init.q, "duty", $$v)
                    },
                    expression: "init.q.duty",
                  },
                }),
                _c("p", { staticClass: "p1" }, [_vm._v("发票号码:")]),
                _c("el-input", {
                  staticStyle: { width: "1.6rem", "margin-right": "0.1rem" },
                  attrs: { size: "small", placeholder: "发票号码" },
                  model: {
                    value: _vm.init.q.fpNumber,
                    callback: function ($$v) {
                      _vm.$set(_vm.init.q, "fpNumber", $$v)
                    },
                    expression: "init.q.fpNumber",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { display: "flex", "align-items": "center" } },
              [
                _c("p", { staticClass: "p1" }, [_vm._v("发票内容:")]),
                _c("el-input", {
                  staticStyle: { width: "1.6rem", "margin-right": "0.1rem" },
                  attrs: { size: "small", placeholder: "发票内容" },
                  model: {
                    value: _vm.init.q.remark,
                    callback: function ($$v) {
                      _vm.$set(_vm.init.q, "remark", $$v)
                    },
                    expression: "init.q.remark",
                  },
                }),
                _c("p", { staticClass: "p1" }, [_vm._v("发票备注:")]),
                _c("el-input", {
                  staticStyle: { width: "1.6rem", "margin-right": "0.1rem" },
                  attrs: { size: "small", placeholder: "发票备注" },
                  model: {
                    value: _vm.init.q.invoicingRemark,
                    callback: function ($$v) {
                      _vm.$set(_vm.init.q, "invoicingRemark", $$v)
                    },
                    expression: "init.q.invoicingRemark",
                  },
                }),
                _c("p", { staticClass: "p1" }, [_vm._v("开票日期:")]),
                _c("el-date-picker", {
                  staticStyle: { "margin-right": "0.1rem", width: "1.5rem" },
                  attrs: {
                    size: "small",
                    "value-format": "yyyy-MM-dd",
                    type: "date",
                    placeholder: "开票日期",
                  },
                  on: {
                    change: function ($event) {
                      ;(_vm.init.page = 1), _vm.getQueryInvoiceList()
                    },
                  },
                  model: {
                    value: _vm.init.q.invoicingTimeStr,
                    callback: function ($$v) {
                      _vm.$set(_vm.init.q, "invoicingTimeStr", $$v)
                    },
                    expression: "init.q.invoicingTimeStr",
                  },
                }),
                _c("p", { staticClass: "p1" }, [_vm._v("收款状态:")]),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "1.6rem", "margin-right": "0.1rem" },
                    attrs: { size: "small", placeholder: "收款状态" },
                    on: {
                      change: function ($event) {
                        ;(_vm.init.page = 1), _vm.getQueryInvoiceList()
                      },
                    },
                    model: {
                      value: _vm.init.q.linkStatus,
                      callback: function ($$v) {
                        _vm.$set(_vm.init.q, "linkStatus", $$v)
                      },
                      expression: "init.q.linkStatus",
                    },
                  },
                  _vm._l(_vm.options1, function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                ),
                _c("p", { staticClass: "p1" }, [_vm._v("开票状态:")]),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "1.6rem", "margin-right": "0.1rem" },
                    attrs: { size: "small", placeholder: "开票状态" },
                    on: {
                      change: function ($event) {
                        ;(_vm.init.page = 1), _vm.getQueryInvoiceList()
                      },
                    },
                    model: {
                      value: _vm.init.q.kpStatus,
                      callback: function ($$v) {
                        _vm.$set(_vm.init.q, "kpStatus", $$v)
                      },
                      expression: "init.q.kpStatus",
                    },
                  },
                  _vm._l(_vm.options2, function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                ),
                _c("p", { staticClass: "p1" }, [_vm._v("申请人:")]),
                _c("el-input", {
                  staticStyle: { width: "1.6rem", "margin-right": "0.1rem" },
                  attrs: { size: "small", placeholder: "申请人" },
                  model: {
                    value: _vm.init.q.createName,
                    callback: function ($$v) {
                      _vm.$set(_vm.init.q, "createName", $$v)
                    },
                    expression: "init.q.createName",
                  },
                }),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        _vm.init.q.page = 1
                        _vm.getQueryInvoiceList()
                      },
                    },
                  },
                  [_vm._v("搜索")]
                ),
                _c(
                  "el-button",
                  { attrs: { size: "small" }, on: { click: _vm.resetClick } },
                  [_vm._v("重置")]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "footer" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c(
              "el-radio-group",
              {
                attrs: { "text-color": "#fff", size: "small", fill: "#E69C37" },
                on: {
                  change: function ($event) {
                    ;(_vm.init.page = 1), _vm.getQueryInvoiceList()
                  },
                },
                model: {
                  value: _vm.init.q.status,
                  callback: function ($$v) {
                    _vm.$set(_vm.init.q, "status", $$v)
                  },
                  expression: "init.q.status",
                },
              },
              _vm._l(_vm.radioList, function (item) {
                return _c(
                  "el-radio-button",
                  { key: item.name, attrs: { label: item.code } },
                  [_vm._v(_vm._s(item.name))]
                )
              }),
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "multipleTable",
          staticStyle: { width: "100%" },
          attrs: {
            "show-overflow-tooltip": "",
            "span-method": _vm.objectSpanMethod,
            border: "",
            data: _vm.tableData,
            "tooltip-effect": "dark",
            "header-cell-style": { color: "#000" },
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "pId",
              fixed: "left",
              align: "center",
              type: "selection",
              width: "55",
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "left",
              width: "160",
              prop: "pId",
              align: "center",
              label: "订单编号",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(scope.row.orderIds, function (item, index) {
                    return _c("p", { key: index }, [
                      _vm._v(" " + _vm._s(item) + " "),
                    ])
                  })
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "left",
              align: "center",
              prop: "createTime",
              label: "申请日期",
              width: "170",
            },
          }),
          _c("el-table-column", {
            attrs: { width: "50", align: "center", prop: "pId", label: "团号" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(" " + _vm._s(scope.row.planId) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              width: "120",
              align: "center",
              prop: "invoicingRemark",
              "show-overflow-tooltip": "",
              label: "发票金额",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", { staticStyle: { color: "rgb(216, 27, 67)" } }, [
                      _vm._v(_vm._s("¥" + scope.row.price)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              width: "150",
              align: "center",
              prop: "lookUp",
              "show-overflow-tooltip": "",
              label: "抬头",
            },
          }),
          _c("el-table-column", {
            attrs: {
              width: "150",
              align: "center",
              prop: "duty",
              "show-overflow-tooltip": "",
              label: "税号",
            },
          }),
          _c("el-table-column", {
            attrs: {
              width: "150",
              align: "center",
              prop: "fpNumber",
              "show-overflow-tooltip": "",
              label: "发票号码",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "remark",
              "show-overflow-tooltip": "",
              label: "发票内容",
              width: "150",
            },
          }),
          _c("el-table-column", {
            attrs: {
              width: "150",
              align: "center",
              prop: "pId",
              "show-overflow-tooltip": "",
              label: "发票备注",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(" " + _vm._s(scope.row.invoicingRemark) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              width: "150",
              align: "center",
              prop: "createTime",
              "show-overflow-tooltip": "",
              label: "开票时间",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "linkStatus",
              "show-overflow-tooltip": "",
              label: "收款状态",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.linkStatusMap[scope.row.linkStatus]) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { width: "250", align: "center", label: "开票状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      { attrs: { type: _vm.statusMap[scope.row.status].type } },
                      [_vm._v(_vm._s(_vm.statusMap[scope.row.status].text))]
                    ),
                    !scope.row.status && scope.row.fileUrl
                      ? _c("span", [_vm._v("（已产生开票信息）")])
                      : _vm._e(),
                    scope.row.status == 2
                      ? _c("div", [
                          _vm._v(
                            " 驳回理由：" + _vm._s(scope.row.rejectReason) + " "
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "pId",
              "show-overflow-tooltip": "",
              label: "申请人",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(" " + _vm._s(scope.row.createName) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              width: "100",
              align: "center",
              label: "下载",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled: !scope.row.fileUrl,
                          size: "mini",
                          type: "success",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.downloadFile(
                              scope.row.fileUrl,
                              scope.row.fileKey
                            )
                          },
                        },
                      },
                      [
                        _vm._v("发票下载 "),
                        _c("a", { attrs: { id: "d" + scope.$index } }),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              prop: "pId",
              width: "100",
              align: "center",
              label: "撤回",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled: _vm.datas
                            .find((n) => n.id === scope.row.pId)
                            .invoicingDetailList.some(
                              (n) =>
                                n.status === 1 || n.fileUrl || n.status === 2
                            ),
                          size: "mini",
                          type: "primary",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.withdraw(scope.row.pId)
                          },
                        },
                      },
                      [_vm._v("发票撤回")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              width: "100",
              align: "center",
              label: "作废",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          disabled: scope.row.status === 1,
                          effect: "dark",
                          content: "后台设置成已开票,才能申请发票作废",
                          placement: "top-start",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: scope.row.status !== 1,
                              size: "mini",
                              type: "warning",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.invoiceVoid(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("申请发票作废")]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              align: "center",
              "show-overflow-tooltip": "",
              label: "关联操作",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.changeAssociation(
                              scope.row.id,
                              scope.row.price,
                              scope.row.planId
                            )
                          },
                        },
                      },
                      [_vm._v("更改关联")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("Pagination", {
        attrs: {
          currentPage: _vm.init.page,
          pageSizes: _vm.pageSizes,
          parentPageSize: 10,
          totalNumber: _vm.AllpagesNum,
        },
        on: { loadTable: _vm.loadTable },
      }),
      _c("changeAssociationPopup", {
        ref: "changeAssociationPopup",
        on: { update: _vm.getQueryInvoiceList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }